import { type UIEvent, useState } from 'react';

import { getLocalAssetUrl } from 'core/utilities';

import { Image } from '../Image';
import { Picture } from './Picture.styles';

import type { PictureProps } from './Picture.d';

export const placeholderImg = getLocalAssetUrl('/images/placeholder.jpg');

const PictureBase = ({ alt, opacity, ratio, sources = [], src, title, ...props }: PictureProps) => {
  const [imageSource, setImageSource] = useState<string | undefined>(src);
  const [isErrorPicture, setIsErrorPicture] = useState(false);

  const onError = ({ currentTarget }: UIEvent<HTMLImageElement>) => {
    currentTarget.onerror = null;
    setImageSource(placeholderImg);
    setIsErrorPicture(true);
  };

  return (
    <Picture.Component data-testid="picture" onError={onError} {...props}>
      {sources.map((sourceItem = {}, index) => (
        <source
          key={`${sourceItem.srcSet}-${index}`}
          media={sourceItem.media}
          srcSet={isErrorPicture ? imageSource : sourceItem.srcSet}
        />
      ))}
      <Image alt={alt} opacity={opacity} ratio={ratio} src={imageSource} title={title} />
    </Picture.Component>
  );
};

export default PictureBase;
